module.exports = __webpack_public_path__ + "static/media/Balenciaga-Red-Knife-Bootie-Lyst.9d355b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Balenciaga-Red-Knife-Bootie-Lyst.png
// module id = 271
// module chunks = 0